var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { Typography, InfoOutlinedIcon, Tooltip, Link, ListItem, ListItemIcon, Box, } from '@kareo/design-system';
import { FacesheetCardList } from 'shared-assets/facesheet-ui/utils/styledFacesheet';
import RecommendationsModal from 'shared-assets/facesheet-ui/components/Facesheet/ClinicalRecommendations/RecommendationsModal';
var StyledList = styled(FacesheetCardList)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& li {\n    border-bottom: 1px solid;\n  }\n"], ["\n  &&& li {\n    border-bottom: 1px solid;\n  }\n"])));
var IconTypography = styled(ListItemIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    margin: 0px 0px 0px 0px;\n    font-size: 26px;\n    weight: strong;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"], ["\n  &&& {\n    margin: 0px 0px 0px 0px;\n    font-size: 26px;\n    weight: strong;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"])));
var StyledListItem = styled(ListItem)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  && {\n    padding: 5px 0 5px 0;\n    margin: 0;\n    list-style-type: none;\n    border-bottom: 1px solid;\n    border-color: lightgray;\n  }\n"], ["\n  && {\n    padding: 5px 0 5px 0;\n    margin: 0;\n    list-style-type: none;\n    border-bottom: 1px solid;\n    border-color: lightgray;\n  }\n"])));
var RecommendationsContent = function (_a) {
    var patientId = _a.patientId, recommendationsData = _a.recommendationsData;
    var _b = useState(false), isClinRecModalOpen = _b[0], setIsClinRecModalOpen = _b[1];
    var _c = useState(0), selectedId = _c[0], setSelectedId = _c[1];
    var _d = useState(new Set()), dismissedRecommendationIds = _d[0], setDismissedRecommendationIds = _d[1];
    var _e = useState(recommendationsData), recommendations = _e[0], setRecommendations = _e[1];
    var openModal = function (id) {
        setSelectedId(id);
        setIsClinRecModalOpen(true);
    };
    var closeModal = function () {
        setIsClinRecModalOpen(false);
    };
    var updateDismissedRecommendations = function (dismissedIds) {
        var dismissedItems = new Set(dismissedIds);
        var prevDismissedIds = Array.from(dismissedRecommendationIds.values());
        prevDismissedIds.forEach(function (id) { return dismissedItems.add(id); });
        setDismissedRecommendationIds(dismissedItems);
    };
    var getIcon = function (grade) {
        if (grade === '!')
            return (React.createElement(IconTypography, null,
                React.createElement(Tooltip, { title: "Configure Clinical Decision Support interventions in Practice Settings > Clinical > Clinical Decision Support." },
                    React.createElement(InfoOutlinedIcon, null))));
        return React.createElement(IconTypography, null, grade);
    };
    var getPreText = function (grade, preText) {
        if (grade === '!')
            return React.createElement("div", null, preText);
    };
    useEffect(function () {
        if (dismissedRecommendationIds.size > 0) {
            var allRecommendations = __spreadArrays(recommendationsData);
            var undismissedRecommendations = allRecommendations.filter(function (recommendation) {
                return !dismissedRecommendationIds.has(recommendation.id);
            });
            setRecommendations(undismissedRecommendations);
        }
    }, [dismissedRecommendationIds.size]);
    return (React.createElement(Box, { height: "300px", overflow: "auto" },
        React.createElement(StyledList, { "aria-label": "clinical recommendation list" }, recommendations.map(function (recommendation) {
            return (React.createElement(StyledListItem, { key: recommendation.id, onClick: function () { return openModal(recommendation.id); } },
                getIcon(recommendation.grade),
                React.createElement(Grid, { container: true, direction: "column" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { variant: "body2", color: "textPrimary", component: "div" },
                            getPreText(recommendation.grade, recommendation.preText),
                            recommendation.topic)),
                    React.createElement(Grid, { item: true },
                        React.createElement(Link, null,
                            React.createElement(Typography, { variant: "body1", component: "div" }, recommendation.title))))));
        })),
        isClinRecModalOpen && (React.createElement(RecommendationsModal, { selectedId: selectedId, patientId: patientId, recommendations: recommendations, isModalOpen: isClinRecModalOpen, closeModal: closeModal, updateDismissedRecommendationIds: updateDismissedRecommendations }))));
};
export default RecommendationsContent;
var templateObject_1, templateObject_2, templateObject_3;
